var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elite-tabs-wrapper-content"},[_c('div',{staticClass:"row"},_vm._l((_vm.request.gallery),function(image,key){return _c('div',{key:key,staticClass:"col-4"},[_c('img',{staticClass:"argon-image mb-2",staticStyle:{"width":"100%"},attrs:{"src":image}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }